import React, {useState, useEffect} from 'react'
import {Button, Input} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import useEmailVerifier from './useEmailVerifier'
import {useLocation} from 'react-router-dom'

const EmailSignin = (props) => {
  const {
    goSignin,
    goSignup,
    emailLabel,
    emailPlaceholder,
    submitLabel,
    showPasswordField,
    passwordLabel,
    passwordPlaceholder,
    forgotText,
    onForgot,
  } = props
  const {translate} = useTranslation()
  const [email, setEmail] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [passwordVisual, setPasswordVisual] = useState('')
  const [errors, setErrors] = useState({})
  const {submit, loading, validationErrors} = useEmailVerifier(
    (user) => {
      if (user.hasFirebaseAuth) {
        // usuario existe en firebase
        global.localStorage.setItem('loggedUser', JSON.stringify(user))
        goSignin()
      } else {
        // usuario NO existe en firebase
        global.localStorage.setItem('signupEmail', email)
        if (user.hasLivePrepUser) {
          global.localStorage.setItem('foundUser', JSON.stringify(user))
        }
        goSignup(user)
      }
    },
    (e) => console.log(e),
  )

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isEducator = searchParams.get('isEducator') === 'true'
  const emailFromParams = searchParams.get('email')

  useEffect(() => {
    if (emailFromParams) {
      setEmail(emailFromParams)
    }
    // eslint-disable-next-line
  }, [searchParams])

  const clearError = (field) => {
    setErrors((prev) => ({...prev, [field]: null}))
  }

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())

  const validate = () => {
    const nextErrors = {}
    if (!email?.trim()) {
      nextErrors.email = 'Please enter your work email.'
    } else if (!isValidEmail(email)) {
      nextErrors.email = 'Please enter a valid email address.'
    }
    if (showPasswordField && !passwordVisual) {
      nextErrors.password = 'Please enter your password.'
    }
    setErrors(nextErrors)
    return Object.keys(nextErrors).length === 0
  }

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (!validate()) return
          submit(email)
        }}
      >
        <div className='field'>
          <label className='field-label'>
            {emailLabel || translate('login.signin.email.label')}
          </label>
        <Input
          className={`field-input ${errors.email ? 'error' : ''}`}
          name='email'
          value={email}
          placeholder={
            emailPlaceholder ||
            translate(`login.signin.email.placeholder${isEducator ? 'Educator' : ''}`)
          }
          onChange={({target: {value}}) => {
            setEmail(value)
            clearError('email')
          }}
        />
          <span className={`field-error ${errors.email ? 'visible' : ''}`}>
            {errors.email || ''}
          </span>
        </div>
        {showPasswordField ? (
          <div className='field'>
            <label className='field-label'>
              {passwordLabel || translate('login.signin.email.passLabel')}
            </label>
            <div className='field-input-wrap'>
              <Input
                className={`field-input ${errors.password ? 'error' : ''}`}
                name='password'
                value={passwordVisual}
                type={showPassword ? 'text' : 'password'}
                placeholder={
                  passwordPlaceholder ||
                  translate('login.signin.email.passPlaceholder')
                }
                onChange={({target: {value}}) => {
                  setPasswordVisual(value)
                  clearError('password')
                }}
              />
              <button
                className='field-toggle'
                type='button'
                onClick={() => setShowPassword((v) => !v)}
              >
                <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'/>
                  <circle cx='12' cy='12' r='3'/>
                </svg>
              </button>
            </div>
            <span className={`field-error ${errors.password ? 'visible' : ''}`}>
              {errors.password || ''}
            </span>
          </div>
        ) : null}
        {showPasswordField ? (
          <a
            className='forgot-link'
            href='/#'
            onClick={(e) => {
              e.preventDefault()
              if (onForgot) onForgot()
            }}
          >
            {forgotText || translate('login.signin.email.forgot')}
          </a>
        ) : null}
        {validationErrors.email ? (
          <div className='my-2 text-center text-error h3 w-100'>
            {translate('login.signin.email.invalid')}
          </div>
        ) : null}
        <Button
          className='btn-primary-login w-100 mt-2'
          color='primary'
          activity={loading}
          type='submit'
          label={submitLabel || translate('login.signin.email.presubmit')}
        />
      </form>
    </div>
  )
}

export default EmailSignin
